<template>
  <div  @click="e=>onBodyClick(e)" class="cmp-distribution-statement_list-statement-sales-import-info">
   <!-- <div class="ut-flex">
       <div>{{$t('client')}}</div>
       <div>{{statementImportInfo.client}}</div>
   </div> 
   <div class="ut-flex">
       <div>{{$t('period')}}</div>
       <div>{{statementImportInfo.period}}</div>
   </div> 
   <div class="ut-flex">
       <div>{{$t('account')}}</div>
       <div>{{statementImportInfo.account_name}}</div>
   </div> 
   <div class="ut-flex">
       <div>{{$t('description')}}</div>
       <div>{{statementImportInfo.description}}</div>
   </div> 
   <div class="ut-flex">
       <div>{{$t('total_lines')}}</div>
       <div>{{statementImportInfo.imported_lines}}</div>
   </div>
   <div class="ut-flex">
       <div>{{$t('Lines with Amount "0"')}}</div>
       <div>{{statementImportInfo.line_zero_ppu}}</div>
   </div>
   <div class="ut-flex">
       <div>{{$t('total_imported_lines')}}</div>
       <div>{{statementImportInfo.total_imported_lines}}</div>
   </div>
   <div class="ut-flex">
       <div>{{$t('matching_lines')}}</div>
       <div>{{statementImportInfo.matching_lines}}</div>
   </div>
   <div class="ut-flex">
       <div>{{$t('import_amount')}}</div>
       <div>{{statementImportInfo.import_amount}}</div>
   </div>
   <div class="ut-flex">
       <div>{{$t('import_amount')}}</div>
       <div>{{statementImportInfo.import_amount}}</div>
   </div>
   <div class="ut-flex">
       <div>{{statementImportInfo.all_sum_cost_pus[0].cost_group_name}}</div>
   </div> -->
   <!-- <div class="ut-flex">
       <div>{{statementImportInfo.all_sum_cost_pus.cost_group_name}}</div>
   </div>
   <div class="ut-flex">
       <div>{{$t('import_amount')}}</div>
       <div>{{statementImportInfo.process_start_time}}</div>
   </div> -->

   

    <div class="ut-fc">
      <div
        class="ut-flex"
        style="
          min-height: 28px;
          align-items: center;
          border-bottom: 1px solid var(--sprt-85);
        "
        v-for="item of statementImportInfo"
        :key="item.key"
      >
        <div style="flex: 1;margin-left:10px">
          {{ $t(item.key) }}
        </div>
        <div style="flex: 0.75">
          <span>{{ item.value }}</span>
        </div>


    
     
      </div> 

    </div>


  </div>
</template>

<script>


import DBox from "@dtplugins/dbox/dbox";
import { onDetailsRowClicked } from '../../../../utility/route';
import { contactListLDTRoutes } from '../../../contacts/router/routes';
import { NotificationService } from '../../../../dt-plugins/notification/notification.service';


export default {
  props: {

    selectedStatementDetails:{
      type:Object,
      default: () => {}
    },
    releaseTypes:{
      type:Array
    }

  },
  components: {
    DBox
   
  },

  data: function() {
    return {
  
    };
  },
  computed:{
    statementImportInfo:function(){
      const importObject= this.selectedStatementDetails?.statement_import_info||{};
      if(importObject!={}){
        return [
          {key:'client',value:importObject.client},
          {key:'period',value:importObject.period},
          {key:'account',value:importObject.account_name},
          {key:'description',value:importObject.description},
          {key:'total_lines',value:importObject.imported_lines},
          {key:'lines_with_amount_zero',value:importObject.line_zero_ppu},
          {key:'total_imported_lines',value:importObject.total_imported_lines},
          {key:'matching_lines',value:importObject.matching_lines},
         
          {key:'import_amount',value:importObject.import_amount},
          {key: importObject.all_sum_cost_pus?.[0]?.cost_group_name , value:''},
          {key: 'import_start_server_time' , value:importObject.process_start_time},
          {key: 'import_end_server_time' , value:importObject.process_end_time},
          {key:'unknown_identfiers',value:importObject.unknown_identfiers}
          
        ]
      }
      return [];
    },
  },
  methods:{
    onBodyClick:function(e){
        const body = e.target;
        
        const textBody = this.statementImportInfo.reduce((accum,cur)=>{
            console.log(`${cur['key']} ${cur['value']}\n`)
            return accum+=`${cur['key']} ${cur['value']}\n`
        },'')

        console.log(';;;;;;;;;;',textBody)
         navigator.clipboard.writeText(textBody).then(
          function () {
            console.log('copied')
            NotificationService.showNotification({
              text: "Info copied to Clipboard",
              timeout: 1000,
            });
          },
          function (err) {
            console.log('err')
            NotificationService.showNotification({
              text: "Text could not be copied to clipboard",
              timeout: 2000,
              type: "error",
            });
          }
        );
    }
  },


}
</script>
<style lang="scss">
.cmp-distribution-statement_list-statement-sales-import-info{
  

    .ut-flex{
        
        // padding-left:10px;
        // padding-top: 5px;
        // flex-wrap: nowrap;
      div:nth-child(1) {
          flex:1.5;
      }

      div:nth-child(2) {
          flex:1;
      }
    }
 

}
</style>